// import chalk from "chalk";

export function error(message: string, willExit?: "exit") {
    // console.error(chalk.bold.red(message));
    if (willExit === "exit") {
        throw new Error(message)
        // process.exit(-1)
    }
}

export function upperFirst(word: string) {
    return word.charAt(0).toUpperCase()
        + word.slice(1)
}